import { useState } from "react";
import {
  DataGridPro as MuiDataGrid,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import ErrorBoundary from "./ErrorBoundary";
import { LinearProgress } from "@mui/material";

function EditableDataGrid({
  columns,
  rows,
  loading,
  doubleClickSlug,
  hiddenColumns,
  processRowUpdate,
  styles,
  readonly,
  rowStyles,
  rowStriping = true,
  initialState = {},
  ...props
}) {
  const [pageSize, setPageSize] = useState(10);
  const apiRef = useGridApiRef();

  /** Automatically hide the ID column and allow
   * other columns to be passed to also be hiddenn */
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    checkboxSelection: false,
    ...hiddenColumns?.map((col) => ({ [col]: false })),
  });

  return (
    <MuiDataGrid
      components={{
        LoadingOverlay: LinearProgress,
      }}
      experimentalFeatures={{ newEditingApi: !readonly }}
      initialState={{
        pagination: {
          pageSize,
        },
        ...initialState,
      }}
      sx={{
        "&.MuiDataGrid-root ": {
          ".MuiDataGrid-row": {
            ".MuiDataGrid-cell:not(.MuiDataGrid-cell--editable)": {
              cursor: "default",
            },
            ...(rowStriping
              ? {
                  "&:nth-of-type(2n)": {
                    backgroundColor: "rgba(235, 235, 235, .7)",
                  },
                }
              : {}),
            ...(rowStyles ?? {}),
          },
        },
      }}
      loading={loading}
      rows={rows}
      columns={columns}
      disableSelectionOnClick
      filterMode="server"
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      pageSize={pageSize}
      apiRef={apiRef}
      columnVisibilityModel={columnVisibilityModel}
      onColumnVisibilityModelChange={(newModel) =>
        setColumnVisibilityModel(newModel)
      }
      processRowUpdate={processRowUpdate}
      {...props}
    />
  );
}

const ErrorCaughtDataGrid = (props) => (
  <ErrorBoundary>
    <EditableDataGrid {...props} />
  </ErrorBoundary>
);

export default ErrorCaughtDataGrid;
